import { Button, CircularProgress, Grid } from "@material-ui/core";
import { Print } from "@material-ui/icons";
import moment from "moment";
import { useContext, useState } from "react";
import { QueryParamsContext } from "../../../../../context/QueryParamsContext";
import { printServiceTaxNotePDF } from "../../../../../repositories/qerpapi/erp/relatorio/NotaFiscalServicoRepository";
import { b64toBlob } from "../../../../../utils/file64toBlob";
import { notify } from "../../../../../utils/notify";
import { periods } from "../../../../financeiro/constants";
import { taxNotesStatus } from "../../constants";
import { useNotaServicoService } from "../../context/NotaServicoContext";
import ExportButton from "../ExportButton";

export const ReportActions = () => {
  const [printLoading, setPrintLoading] = useState(false);
  const {
    columns,
    cachedNotes,
    filters,
    cachedCompanies,
    cachedClients,
    formatSortedLabel,
  } = useNotaServicoService();
  const { queryParams } = useContext(QueryParamsContext);

  const data = cachedNotes.data;

  const handlePrintToPdf = async () => {
    const filtersDescriptions = {
      period: {
        label: "Período",
        formatedValue: (searchPeriod) => {
          const objEntries = Object.entries(periods);
          const [key] = objEntries.find(([_, value]) => value === searchPeriod);
          return key;
        },
      },
      startDate: {
        label: "Data inicial",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },
      endDate: {
        label: "Data final",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },

      multicompany: {
        label: "Empresa",
        formatedValue: (company) => {
          const objEntries = Object.entries(cachedCompanies);
          const companies = objEntries.find(([_, value]) => value === company);
          return companies[0] ?? queryParams?.nomeempresa;
        },
      },

      customer: {
        label: "Cliente",
        formatedValue: (customer) => {
          if (!customer) return "Todos";

          const customers = cachedClients.find(
            ({ value }) => value === customer
          );
          return customers[0] ?? queryParams?.nomeempresa;
        },
      },

      multipleSort: {
        label: "Ordenado por:",
        formatedValue: formatSortedLabel,
      },
      status: {
        label: "Status",
        formatedValue: (statusFilter) => {
          const objEntries = Object.entries(taxNotesStatus);
          const [key] = objEntries.find(([_, value]) => value === statusFilter);
          return key;
        },
      },
      noteNumber: {
        label: "Nº Nota",
        formatedValue: (contractNumber) => contractNumber || "Todos",
      },
      rpsNumber: {
        label: "Nº RPS",
        formatedValue: (contractNumber) => contractNumber || "Todos",
      },
    };

    setPrintLoading(true);

    const pdfBody = {
      title: "Relatório de Nota Fiscal de Serviços",
      type: "DETALHADO",
      order: formatSortedLabel(filters.multipleSort),
      companyName: queryParams?.nomeempresa,
      companyFantasy: queryParams?.apelido,
      headerLogo: queryParams?.imagebase64,
      footerLogo: queryParams?.imagebase64,
      login: queryParams?.usuario_nome,
      filter: Object.entries(filters)
        .filter(([key, _]) => !!filtersDescriptions[key])
        .map(([key, value]) => ({
          field: filtersDescriptions[key].label,
          value: filtersDescriptions[key].formatedValue(value),
        })),
      movement: data,
      searchPeriod: cachedNotes.period,
      total: {
        amount: 0,
        balance: 0,
        originalAmount: 0,
        debit: 0,
        debitPerCent: 0,
        credit: 0,
        creditPerCent: 0,
        increase: 0,
        discount: 0,
      },
    };
    const res = await printServiceTaxNotePDF(pdfBody);
    setPrintLoading(false);
    if (res?.status !== 200) {
      return notify("Falha ao imprimir relatório", true, "error");
    }

    const blob = b64toBlob(res?.data?.fileBase64, "application/pdf");
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  };

  const isEmpty = data.every((item) => !item.elements.length);

  return (
    <Grid item container direction="row" spacing={1}>
      <Grid item xs />
      <Grid item>
        <ExportButton
          data={data}
          filename={`nota-servicos-${Date.now()}`}
          columns={columns}
        />{" "}
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          startIcon={printLoading ? <CircularProgress size={16} /> : <Print />}
          color="primary"
          disabled={printLoading || isEmpty}
          onClick={handlePrintToPdf}
        >
          {printLoading ? "Gerando relatório..." : "Imprimir"}
        </Button>
      </Grid>
    </Grid>
  );
};
